import * as React from 'react'
import { getPetsWIthDevices } from '../../helpers/dataHelpers.ts'
import { IDevice, IPet } from '../../interfaces/types.ts'
import dataStore from '../../store/dataStore.ts'
import './PetDrawer.css'
import { centerMapOnPet } from '../map/mapHelpers.tsx'
import { Battery } from '../common/device/Battery.tsx'
import { fenceIcon } from '../../helpers/colorHelper.ts'
import { faMoon } from '@fortawesome/free-solid-svg-icons/faMoon'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isSleepFeatureEnabled, isLedFeatureEnabled, hasScheduledSleep } from '../../helpers/sleepHelper.ts'
import { AlarmClockIcon } from '../svgs/AlarmClockIcon.tsx'
import { faMagnifyingGlassLocation } from '@fortawesome/free-solid-svg-icons/faMagnifyingGlassLocation'
import { faHeartCircleCheck } from '@fortawesome/free-solid-svg-icons/faHeartCircleCheck'
import { faList } from '@fortawesome/free-solid-svg-icons/faList'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons/faLightbulb'
import { findDevice, sendCommand } from '../../helpers/commandHelper.ts'
import { useNavigate } from 'react-router-dom'
import { ChangeCheckInRate } from '../common/ChangeCheckInRate/ChangeCheckInRate.tsx'
import { ScheduleSleep } from '../common/ScheduleSleep/ScheduleSleep.tsx'
import { computeActivityStatus } from '../../helpers/activityStatusHelper.ts'
import { useNowTick } from '../../hooks/useNowTick.ts'

const SMALL_SCREEN = 360

// const iconSize = 'xl'
export const MiniPetList: React.FC = () => {
    const petsWithDevices: string[] = getPetsWIthDevices()
    const devices = dataStore(s => s.devices)
    const _pets = dataStore(s => s.pets)
    const account = dataStore(s => s.account)
    const sleepFeatureEnabled = isSleepFeatureEnabled(account)
    const ledFeatureEnabled = isLedFeatureEnabled()
    const pets = _pets.filter(p => petsWithDevices.includes(p._id)).sort((a, b) => a.petName > b.petName ? 1 : -1)
    const navigate = useNavigate()

    // Re-render every 30s so activity status (overdue detection) stays current
    // even when no new device updates arrive
    useNowTick()

    const [checkinOpenId, setCheckinOpenId] = React.useState<string | null>(null)
    const [sleepOpenId, setSleepOpenId] = React.useState<string | null>(null)

    let imageSize = 60
    if (window.innerWidth < SMALL_SCREEN) {
        imageSize = 40
    }

    const getList = (pets: IPet[], devices: IDevice[]) => {
        return pets.map(pet => {
            const d = devices.find(d1 => d1.petId === pet._id)
            if (!d) {
                return null
            }
            let safeZone = 'In'
            if (d.status.safeZoneViolation) {
                safeZone = 'Out'
            }

            const powerSavingMode = d.status.beaconInRange && d.status.powerOn
            const isCharging = d.status.charging
            let findDisabled= !d?.status.powerOn || powerSavingMode
            findDisabled = isCharging ? false : findDisabled
            findDisabled = d?.status.deviceCommandInProgressStatus ? true : findDisabled
            const safeZoneName = d.status.occupiedZone || 'Safe Zone'
            // const rate = readableSeconds(d.status.backgroundInterval).split(' ')

            // const locationDate = d?.lastLocation?.properties?.receivedTime ? DateTime.fromISO(d.lastLocation.properties.receivedTime)
            //     .setZone(authStore.getState().timezone.value).toLocaleString(DateTime.DATETIME_MED_WITH_WEEKDAY)
            //     : 'No locations received'

            // const displayedDate = (
            //     <div className={'flex flex-col'}>
            //         <div className={'text-primary-content text-md font-semibold ml-12'}>{locationDate}</div>
            //         {/* {off || inPowerSavingMode || staleWarning}*/}
            //     </div>
            // )

            // const inPowerSavingMode = powerSavingMode ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         Power Save Mode
            //     </div>
            //     : null

            // const off = !d.status.powerOn ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         Gibi Off
            //     </div>
            //     : null

            // const inCharger = d.status.charging ?
            //     <div
            //         className={'rounded px-1 h-[14px] m-auto w-fit text-center bg-primary-content text-sm text-accent font-bold leading-[14px]'}>
            //         In Charger
            //     </div>
            //     : null

            const petName = (
                <div className={''}>
                    <div className={'text-primary-content text-3xl font-bold text-left pl-2'}>
                        {pet.petName}
                    </div>
                </div>
            )

            const safeZoneIndicator = (
                <div className={'flex flex-col items-center self-start relative'}>
                    <div
                        className={`font-semibold text-lg flex items-center justify-center rounded-full w-[33.5px] h-[33.5px] border-2 border-white ${safeZone === 'In' ? 'bg-success' : 'bg-gray-400'}`}>
                        <img className={'w-8 mt-2'}
                             src={fenceIcon(safeZone === 'In' ? '#ffffff' : '#fff')}/>
                    </div>
                    <div
                        className={'absolute -bottom-[20px] -left-[14px] w-[65px] overflow-hidden bg-transparent text-primary-content pr-2.5 text-nowrap'}>
                        {safeZoneName}
                    </div>
                </div>
            )

            const batteryIndicator = (
                <div className={'self-start pb-2'}>
                    <Battery pet={pet} iconOnly mobile/>
                </div>
            )

            const beaconIndicator = (
                <div className={'relative h-full flex flex-col gap-1 items-center relative self-start'}>
                    {/*<div*/}
                    {/*    className={'bg-transparent text-primary-content -mt-[14px]'}>*/}
                    {/*    Power*/}
                    {/*</div>*/}
                    <div
                        className={`flex items-center justify-center rounded-full w-[33.5px] h-[33.5px] border-2 border-white ${powerSavingMode ? 'bg-success' : 'bg-gray-400'}`}>

                    </div>
                    <div
                        className={'bg-transparent text-primary-content'}>
                        Pwr Saving
                    </div>
                </div>
            )

            const isSleeping = d.status.sleeping === true
            const isScheduled = hasScheduledSleep(d.status)
            const sleepBg = isSleeping ? 'bg-success' : isScheduled ? 'bg-white' : 'bg-gray-400'
            const commandDisabled = findDisabled || isSleeping || !!d.status.deviceCommandInProgressStatus
            const ledState = d.status.ledState ?? 0
            const nextLedState = ledState === 0 ? 1 : ledState === 1 ? 2 : 0
            const ledLabel = ledState === 0 ? 'Turn LED On' : ledState === 1 ? 'LED Auto (1 min)' : 'Turn LED Off'

            const petAvatar = (
                <div className={'relative'}>
                    <div className={'rounded-full border border-2 border-white'}>
                        <div className={'rounded-full border border-4'} style={{borderColor: pet.iconColor}}>
                            <div className={'rounded-full border border-2 border-white cursor-pointer'}
                                 onClick={() => centerMapOnPet(pet)}>
                                <img src={pet.imageURL}
                                     style={{
                                         height: `${imageSize}px`,
                                         width: `${imageSize}px`,
                                         borderRadius: '50%',
                                     }}
                                />
                            </div>
                        </div>
                    </div>
                    {/* LED badge — bottom-right corner of avatar */}
                    {ledFeatureEnabled && (
                        <button
                            className={`absolute bottom-0 right-0 w-5 h-5 rounded-full border-2 border-white flex items-center justify-center cursor-pointer ${commandDisabled ? 'opacity-50 cursor-not-allowed' : ''}`}
                            style={{ backgroundColor: ledState === 1 ? 'hsl(var(--su))' : ledState === 2 ? 'hsl(var(--wa))' : 'hsl(var(--b3))' }}
                            disabled={commandDisabled}
                            onClick={e => { e.stopPropagation(); !commandDisabled && sendCommand('setLed', d.iccid, nextLedState) }}
                            title={ledLabel}
                        >
                            <FontAwesomeIcon icon={faLightbulb} style={{ fontSize: '9px', color: 'white' }} />
                        </button>
                    )}
                </div>
            )
            const sleepIndicator = sleepFeatureEnabled ? (
                <div className={'flex flex-col gap-1 items-center self-start'}>
                    <div className={`flex items-center justify-center rounded-full w-[33.5px] h-[33.5px] border-2 border-white ${sleepBg}`}>
                        {isScheduled && !isSleeping
                            ? <AlarmClockIcon color="hsl(var(--su))" size={18} />
                            : <FontAwesomeIcon icon={faMoon} className={'text-white text-lg'} />
                        }
                    </div>
                    <div className={'bg-transparent text-primary-content text-nowrap'}>Sleep</div>
                </div>
            ) : null

            // Shared mobile button style
            const mbtn = (isDisabled: boolean) =>
                `w-full h-full rounded-lg border border-white flex flex-col items-center justify-center gap-0.5 text-white text-[11px] font-semibold whitespace-nowrap transition-[filter] ${isDisabled ? 'bg-gray-400 opacity-60 cursor-not-allowed' : 'bg-secondary hover:brightness-110 cursor-pointer'}`

            // Activity status for at-a-glance card styling
            const activityStatus = computeActivityStatus(d)
            const isInactive = activityStatus.level === 'inactive'
            const isDegraded = activityStatus.level === 'degraded'
            const isOverdue = isInactive && activityStatus.reason === 'overdue'

            const indicators = (
                <div onClick={() => centerMapOnPet(pet)} className={'flex flex-col p-2 gap-1'}>
                    {petName}
                    <div className={'flex items-center justify-between w-full h-[78px]'}>
                        {petAvatar}
                        {sleepFeatureEnabled ? (
                            <div className={'flex-1 grid grid-cols-2 gap-x-1 gap-y-0 items-center justify-items-center content-center -mt-1'}>
                                {safeZoneIndicator}
                                {beaconIndicator}
                                {sleepIndicator}
                                {batteryIndicator}
                            </div>
                        ) : (
                            <div className={'flex items-center justify-around w-[65%] pt-6'}>
                                {safeZoneIndicator}
                                {beaconIndicator}
                                {batteryIndicator}
                            </div>
                        )}
                    </div>
                </div>
            )

            const buttons = (
                <div className={'p-1.5 border-l-2 border-l-primary-content border-opacity-20 grid grid-cols-2 gap-1'} style={{ width: '11rem' }}>
                    <button
                        className={`${mbtn(commandDisabled)} ${!sleepFeatureEnabled ? 'col-span-2' : ''}`}
                        disabled={commandDisabled}
                        onClick={() => !commandDisabled && findDevice(d)}>
                        <FontAwesomeIcon icon={faMagnifyingGlassLocation} />
                        <span>Find</span>
                    </button>

                    <button className={mbtn(commandDisabled)} disabled={commandDisabled}
                        onClick={() => !commandDisabled && setCheckinOpenId(d._id)}>
                        <FontAwesomeIcon icon={faHeartCircleCheck} />
                        <span>Check-in</span>
                    </button>

                    {sleepFeatureEnabled ? (
                        <button className={mbtn(commandDisabled)} disabled={commandDisabled}
                            onClick={() => !commandDisabled && setSleepOpenId(d._id)}>
                            <FontAwesomeIcon icon={faMoon} />
                            <span>Sleep</span>
                        </button>
                    ) : (
                        <button className={mbtn(false)}
                            onClick={() => navigate('/events', { state: { pet } })}>
                            <FontAwesomeIcon icon={faList} />
                            <span>Events</span>
                        </button>
                    )}

                    {sleepFeatureEnabled && (
                        <button className={mbtn(false)}
                            onClick={() => navigate('/events', { state: { pet } })}>
                            <FontAwesomeIcon icon={faList} />
                            <span>Events</span>
                        </button>
                    )}
                </div>
            )

            return (
                <React.Fragment key={pet._id}>
                    <div className={`relative bg-primary text-primary-content rounded-xl mx-1 flex flex-col`}>
                        {/* Activity status dot */}
                        {(isDegraded || isInactive) && (
                            <div className={`absolute top-2 right-2 w-3 h-3 rounded-full border border-white/50
                                ${isOverdue ? 'bg-error animate-pulse' : isDegraded ? 'bg-amber-400 animate-pulse' : 'bg-gray-600'}`}
                            />
                        )}
                        {/* Main card row */}
                        <div className={'grid grid-cols-[1fr_auto]'}>
                            {indicators}
                            {buttons}
                        </div>
                    </div>
                    {checkinOpenId === d._id && (
                        <ChangeCheckInRate tracker={d} open={true} setOpen={(o) => !o && setCheckinOpenId(null)} disabled={commandDisabled} />
                    )}
                    {sleepOpenId === d._id && (
                        <ScheduleSleep tracker={d} open={true} setOpen={(o) => !o && setSleepOpenId(null)} disabled={commandDisabled} />
                    )}
                </React.Fragment>
            )
        })
    }

    const list = (devices && pets) ? getList(pets, devices) : []

    return <div className={'bg-transparent flex flex-col gap-2'}>{list}</div>
}
